<ras-page [show_heading]="false" [thin_footer]="true" [menu]="false">
	<section class="heading">
		<div>
			<div>
				<h1>How To Get More Space Without Having to Move House</h1>
				<p>The clutter is all in the mind</p>
			</div>
			<img src="/assets/eBook-header-get-more-space.png" />
		</div>
	</section>

	<section>
		<div *ngIf="!submitted">
			<div>
				<form #form [ngClass]="{show_invalid: show_invalid, submitting: submitting}">
					<p>To download the FREE <i>How to get more space without having to move</i> guide and save yourself a whole lot of stress, complete this form:</p>
					<label class="short">
						First name
						<input [disabled]="submitting" type="text" required [(ngModel)]="first_name" name="first_name" />
					</label>
					<label class="short">
						Last name
						<input [disabled]="submitting" type="text" required [(ngModel)]="last_name" name="last_name" />
					</label>
					<label>
						Phone number
						<input [disabled]="submitting" type="text" required [(ngModel)]="phone" name="phone" />
					</label>
					<label>
						Email
						<input [disabled]="submitting" type="email" required [(ngModel)]="email" name="email" />
					</label>
					<ras-captcha (success)="captcha_success()"></ras-captcha>
					<button [disabled]="submitting" (click)="submit()" [disabled]="!captcha_correct">Get eBook</button>
				</form>
			</div>

			<div class="wider">
				<h2>Our eBook is going to help you overcome the clutter and its related chaos.</h2>

				<p>In this short but incredibly useful eBook you will learn:</p>

				<ul>
					<li>How to prepare yourself mentally to sort out your space.</li>
					<li>What to do if you have hoarding tendencies.</li>
					<li>How to get everyone involved.</li>
					<li>How to let go of what you no longer need.</li>
					<li>How to handle what you want to keep but just can't fit.</li>
					<li>How to get it done – life hacks.</li>
					<li>How to keep it tidy.</li>
				</ul>

				<hr />

				<p>We really hope you get some value from this e-book, and wish you the best with your move!</p>
			</div>
		</div>
		<div *ngIf="submitted">
			<div class="wider">
				<h2 class="success">Thanks for downloading our eBook!</h2>

				<p><a target="_blank" href="/assets/ebook-declutter-your-home.pdf">Download: How to get more space without having to move house</a></p>

				<p>We know. It’s not easy. We’ll be staying in touch to give you some support with more tips and tricks and if you ever need extra space – we’re standing by to be of service!</p>

				<p>Did you know that you can get your first month free at one of Rent-A-Store’s high security A-Grade facilities, with free move in transport? Tap below for more:</p>

				<p><a href="/rent-now">Yes! I want my first month free.</a>

<!-- 				<p>A link will be sent to your email. If you did not receive an email, please <a target="_blank" href="/assets/ebook-declutter-your-home.pdf">click here</a>.</p>
				<p>We know. It’s not easy. We’ll be staying in touch to give you some support with more tips and tricks and if you ever need extra space – we’re standing by to be of service!</p>
 -->
				<hr />
				<p>Need to store some stuff? We’ve sent you a month of free Rent-A-Store storage to help!</p>
				<p><b>Check your mail to download your coupon.</b></p>
			</div>
			<div>
				<img src="/assets/eBook-get-more-space.png" width="638px" />
			</div>
		</div>
	</section>
</ras-page>
